import { BLOB_CONTAINER, BlobContainerType, BlobContainerTypeName, blobsApi } from "api/blobsApi";
import { useEffect, useState } from "react";
import { PaziaModal } from "components/molecules";

type Props = {
  href: string;
};

const InvoicePreview = ({ href }: Props) => {
  return (
    <object data={href} type="application/pdf" width="100%" height="100%">
      {/* <iframe
        src={href}
        width="100%"
        height="100%"
        // style="border: none;"
      >
        <p>
          Your browser does not support PDFs.
          <a href={href}>Download the PDF</a>.
        </p>
      </iframe> */}
    </object>
  );
};

interface PdfBlobPreviewModalProps {
  onCloseRequest: () => void;
  blobName?: string | null;
  containerType: BlobContainerTypeName;
}

export const PdfBlobPreviewModal = ({ onCloseRequest, blobName, containerType }: PdfBlobPreviewModalProps) => {
  const [fileUrl, setFileUrl] = useState<string | null>(null);

  useEffect(() => {
    if (blobName) {
      blobsApi.getSasUrl(blobName, BLOB_CONTAINER[containerType]).then((response) => {
        setFileUrl(response.data);
      });
    }
  });
  return (
    <PaziaModal
      id="prev-file-modal"
      onCloseRequest={() => {
        setFileUrl(null);
        onCloseRequest();
      }}
      isOpen={blobName != null}
      size="7xl"
      className="h-full w-[90%] max-w-[90%]"
    >
      {fileUrl && <InvoicePreview href={fileUrl} />}
    </PaziaModal>
  );
};
